import gymRequest from '@apis/gym'
import {Box, Flex, Text} from '@chakra-ui/react'
import {Progress as ProgressAnt} from 'antd'
import {useEffect, useState} from 'react'

interface Statistics {
  avg_score: number
  good_ipa: IPAItem[]
  bad_ipa: IPAItem[]
}

interface IPAItem {
  ipa: string
  score: number
}

const COLORS = {
  success: '#6AC985',
  warning: '#FFCD00',
  error: '#E55856',
  successBg: '#DAF1E0',
  warningBg: '#FFF5CC',
  errorBg: '#FADEDD',
} as const

const SCORE_THRESHOLDS = {
  low: 50,
  medium: 75,
} as const

const SkillCard = () => {
  const [statistics, setStatistics] = useState<Statistics>()

  useEffect(() => {
    getStatistics()
  }, [])

  const getStatistics = async () => {
    try {
      const statisticsData = await gymRequest.getStatistics()
      setStatistics(statisticsData?.data?.data)
    } catch (error) {
      console.log(error)
    }
  }

  const getStrokeColor = (score: any): string => {
    if (score < SCORE_THRESHOLDS.low) return COLORS.error
    if (score < SCORE_THRESHOLDS.medium) return COLORS.warning
    return COLORS.success
  }

  const getTrailColor = (score: any): string => {
    if (score < SCORE_THRESHOLDS.low) return COLORS.errorBg
    if (score < SCORE_THRESHOLDS.medium) return COLORS.warningBg
    return COLORS.successBg
  }

  const Feedback = ({
    data,
    title,
    color,
    bgColor,
  }: {
    data: any
    title: string
    color: string
    bgColor: string
  }) => {
    return (
      <Box>
        <Text fontSize={'16px'} color={'#101828'} mt={'24px'}>
          {title}
        </Text>
        {data?.map((item: any, index: number) => {
          return (
            <Flex
              key={index}
              flexDirection={'column'}
              justifyContent={'center'}
              gap={'12px'}
              mt={'12px'}
              fontWeight={700}>
              <Flex justifyContent={'space-between'}>
                <Text>{`/${item?.ipa}/`}</Text>
                <Text
                  color={color}>{`${Math.round(Number(item?.score))}%`}</Text>
              </Flex>
              <Flex gap={'4px'}>
                {[...Array(5)].map((_, i) => {
                  const score = Number(item?.score)
                  const segmentSize = 20 // Mỗi phần chiếm 20% (100/5)
                  const segmentStart = i * segmentSize
                  const segmentEnd = (i + 1) * segmentSize

                  let fillPercentage
                  if (score <= segmentStart) {
                    fillPercentage = 0
                  } else if (score >= segmentEnd) {
                    fillPercentage = 1
                  } else {
                    fillPercentage = (score - segmentStart) / segmentSize
                  }

                  return (
                    <Box
                      key={i}
                      flex={1}
                      h={'10px'}
                      borderRadius={'10px'}
                      position="relative"
                      overflow="hidden">
                      <Box
                        position="absolute"
                        left={0}
                        top={0}
                        bottom={0}
                        width={`${fillPercentage * 100}%`}
                        bg={color}
                      />
                      <Box
                        position="absolute"
                        right={0}
                        top={0}
                        bottom={0}
                        left={`${fillPercentage * 100}%`}
                        bg={bgColor}
                      />
                    </Box>
                  )
                })}
              </Flex>
            </Flex>
          )
        })}
      </Box>
    )
  }

  return (
    <Box
      mt={{base: '16px', lg: '32px'}}
      bg={'white'}
      borderRadius={'16px'}
      border={'1px solid #EFEFEF'}>
      <Box px={'20px'} py={'24px'}>
        <Text fontSize={'24px'} fontWeight={600} align={'center'} pt={'24px'}>
          Kỹ năng phát âm
        </Text>
        <Flex
          justifyContent={'center'}
          mt={'30px'}
          mb={'16px'}
          color={'#FFCD00'}>
          <ProgressAnt
            size={140}
            type="dashboard"
            strokeWidth={8}
            format={percent => (
              <Text
                fontSize={'34px'}
                color={getStrokeColor(percent)}
                fontWeight={700}>
                {percent}%
              </Text>
            )}
            percent={statistics?.avg_score}
            strokeColor={getStrokeColor(statistics?.avg_score)}
            trailColor={getTrailColor(statistics?.avg_score)}
          />
        </Flex>
        <Text fontSize={'16px'} fontWeight={600} align={'center'}>
          So với người bản xứ
        </Text>
        <Feedback
          data={statistics?.good_ipa}
          title={'Các âm làm tốt'}
          color={COLORS.success}
          bgColor={COLORS.successBg}
        />
        <Feedback
          data={statistics?.bad_ipa}
          title={'Các âm cần cải thiện'}
          color={COLORS.error}
          bgColor={COLORS.errorBg}
        />
      </Box>
    </Box>
  )
}

export default SkillCard
